import type { AxiosResponse } from 'axios'
import type { ActionLog, Pagination, PaginationParams, SortParams } from 'types'

export enum Actions {
  GET_ACTION_LOG = 'GET_ACTION_LOG',
  SET_ACTION_LOG = 'SET_ACTION_LOG',
  RESET_ACTION_LOG = 'RESET_ACTION_LOG',
}

export type ActionLogs = {
  data: ActionLog[]
} & Pagination

export type GetActionLogByIdPayload = {
  id: string
} & PaginationParams &
  SortParams

export type GetActionLogByIdResponse = AxiosResponse<ActionLogs>
